export default "__VITE_ASSET__3b9b9d5d__"